import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatIncidents = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.incidentNumber}`,
        value: item._id,
        resolutionDate: item.resolutionDate && moment(item.resolutionDate),
        plannedStartDate: item.plannedStartDate && moment(item.plannedStartDate),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchIncidents,
    create: createIncident,
    update: updateIncident,
    delete: deleteIncidents
} = createCrudActions('INCIDENT', "Incidencia", formatIncidents);
